<template>
    <div class="menu-container">
        <div class="collapse-button" v-on:click="handleCollapseClick">
            <i :class="!isCollapsed ? 'el-icon-s-fold' : 'el-icon-s-unfold'" style="font-size: 18px"></i>
        </div>
        <el-menu style="flex: 1; border-right: none;"
                 :default-active="currentMenu"
                 @open="handleOpen"
                 @close="handleClose"
                 @select="handleClick"
                 class="main-menu"
                 background-color="#545c64"
                 text-color="#fff"
                 active-text-color="#ffd04b"
                 :collapse="isCollapsed">
            <template v-for="menu in menuList">
                <el-menu-item v-if="!menu.subMenus" :index="menu.path" :route="menu" :key="menu.menuKey">
                    <i :class="menu.icon" v-if="menu.icon"></i><span slot="title">{{menu.caption}}</span>
                </el-menu-item>
                <el-submenu :index="menu.path" v-if="menu.subMenus&&menu.subMenus.length">
                    <template slot="title"><i :class="menu.icon" v-if="menu.icon"></i><span slot="title">{{menu.caption}}</span></template>
                    <el-menu-item v-for="child in menu.subMenus" :index="child.path" :key="child.menuKey" >
                        <i :class="child.icon" v-if="child.icon"></i><template slot="title">{{child.caption}}</template>
                    </el-menu-item>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</template>

<script>
import menu from "@/config/menu";
export default {
    name: "SideMenu",
    data()
    {
        return {
            menuList: this.$store.state.layout.menuList,
            isCollapsed: false,
        }
    },
    methods:
    {
        handleOpen(key, keyPath)
        {
            console.log(this.$store);
            console.log(key, keyPath);
        },
        handleClose(key, keyPath)
        {
            console.log(key, keyPath);
        },
        handleClick(index, key, t)//index path
        {
            console.log('handleClick:',index, key);
            // let menuItem = menu.getMenuByKey(index);
            // console.log('click',path, keyPath, t);
            this.$router.push(index);
            console.log(this.$route, this.$router);
            let caption = this.$route.meta.caption;
            this.$store.dispatch('layout/openTab',{caption, path: index});
        },
        handleCollapseClick(e) {
            this.isCollapsed = !this.isCollapsed;
        }
    },
    mounted()
    {
    },
    computed:
    {
        currentMenu:
        {
            get: function()
            {
                return this.$store.state.layout.currentTab;
            },
            set:  function (path)
            {
            }
        },
    }
}
</script>

<style scoped>
/*.el-submenu .el-menu-item*/
/*{*/
/*    min-width: auto;*/
/*}*/
.main-menu:not(.el-menu--collapse) {
    width: 200px;
}
.menu-container {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}
.collapse-button {
    color: white;
    cursor: pointer;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(84, 92, 100);
}
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/index/component/SideMenu.vue